import { FormField } from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormEntityContext } from '../../config/context/forms'
import FieldWrapper from './FieldWrapper'
import { Textarea } from '@/components/ui/textarea'
import { FieldProps } from './types'
import { cn } from '@/lib/utils'

const TextField = ({
  customLabel,
  customDescription,
  customPlaceholder,
  className,
  inputClassName,
  name,
  layout = 'inline',
  isMulti,
  resetValue,
  disabled = false,
  trimOnBlur = false,
  ...inputProps
}: FieldProps<string> & { trimOnBlur?: boolean }) => {
  const { i18n, t } = useTranslation()
  const form = useFormContext()
  const { entityType, i18nPrefix } = useContext(FormEntityContext)

  const description =
    customDescription ??
    (i18n.exists(`${i18nPrefix}.${entityType}.${name}.description`)
      ? t(`${i18nPrefix}.${entityType}.${name}.description`)
      : undefined)

  return (
    <div className={`${className ?? ''} w-full`}>
      <FormField
        control={form.control}
        name={name}
        render={({ field }) => {
          return (
            <FieldWrapper
              layout={layout}
              label={
                customLabel ?? t(`${i18nPrefix}.${entityType}.${name}.label`)
              }
              description={description}
              resetValue={resetValue}
            >
              {isMulti ? (
                <Textarea
                  className={cn('min-h-[80px]', inputClassName)}
                  placeholder={t(
                    customPlaceholder ??
                      `${i18nPrefix}.${entityType}.${name}.placeholder`,
                  )}
                  {...field}
                  disabled={disabled}
                />
              ) : (
                <Input
                  type={'text'}
                  placeholder={t(
                    customPlaceholder ??
                      `${i18nPrefix}.${entityType}.${name}.placeholder`,
                  )}
                  className={`${layout === 'box' ? 'w-full md:w-24' : ''} ${
                    inputClassName ?? ''
                  }`}
                  {...field}
                  {...inputProps}
                  disabled={disabled}
                  onBlur={(e) => {
                    if (trimOnBlur) {
                      const trimmed = e.target.value.trim()
                      if (trimmed !== field.value) {
                        form.setValue(name, trimmed, {
                          shouldDirty: true,
                          shouldValidate: true,
                        })
                      }
                    }
                    field.onBlur()
                    inputProps.onBlur?.(e)
                  }}
                />
              )}
            </FieldWrapper>
          )
        }}
      />
    </div>
  )
}

export default TextField
